import {
  AbsenceReasonCategory,
  AbsenceResponse,
  AbsenceState,
} from '@mnspro-cloud/services/lib/mnspro-cloud/api/v2';
import { t } from 'i18next';
import moment from 'moment';

const getReasonDisplayText = (absence: AbsenceResponse) => {
  if (absence.absenceReason !== null && absence.absenceReason?.fullName) {
    return absence.absenceReason.fullName;
  }

  if (
    absence.absenceReason === null &&
    absence.state === AbsenceState.present
  ) {
    return t('classbook:absences:absencereason_present', { defaultValue: 'Anwesend' });
  }
  return t('classbook:absences:absencereason_notchecked', { defaultValue: 'Nicht geprüft' });
};

export const getAbsenceReasonText = (absence: AbsenceResponse) => {
  const absenceReasonCategory = absence.absenceReason?.category;
  if (
    absenceReasonCategory === AbsenceReasonCategory.late ||
    absenceReasonCategory === AbsenceReasonCategory.leftEarly
  ) {
    const offset = absence.offset;
    return offset && offset !== '00:00:00'
      ? `${getReasonDisplayText(absence)} (${moment
          .duration(offset)
          .minutes()} ${t('classbook:absences:absencereason_min', { defaultValue: 'Min.' })})`
      : `${getReasonDisplayText(absence)}`;
  } else {
    return `${getReasonDisplayText(absence)}`;
  }
};
